import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AlertService, AlertTypeEnum } from '../services/alert.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const storage = inject(StorageService);
  const router = inject(Router);
  const alertService = inject(AlertService);

  // Get token from storage
  const token = storage.getItem('auth_token');

  // Clone request and add authorization header if token exists
  let authReq = req;
  if (token) {
    authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      },
    });
  } else {
    authReq = req.clone({
      setHeaders: {
        Accept: 'application/json',
      },
    });
  }

  return next(authReq).pipe(
    catchError((error) => {
      // Handle 401 Unauthorized
      if (error.status === 401) {
        storage.removeItem('auth_token');
        storage.removeItem('user');
        alertService.showAlert(AlertTypeEnum.ERROR, 'Session expired. Please login again.');
        router.navigate(['/auth/login']);
      }

      // Handle 403 Forbidden
      if (error.status === 403) {
        if(error.error?.code==='TERMS_REQUIRED') void router.navigate(['/council/web-terms']);
        else alertService.showAlert(AlertTypeEnum.ERROR, error.error?.message || 'You do not have permission to perform this action. Ask your administrator to check your access.');
      }

      if (error.status === 423) {
        alertService.showAlert(
          AlertTypeEnum.ERROR,
          error.error?.message || 'This CRC is suspended. Operations are locked.'
        );
      }

      // Handle 500 Server Error
      if (error.status === 500) {
        alertService.showAlert(AlertTypeEnum.ERROR, 'Server error. Please try again later.');
      }

      return throwError(() => error);
    })
  );
};
